module.exports = __webpack_public_path__ + "img/multiplier3_normal.b974a0b0.png";